<template>
  <div class="hierarchy-selector">
    <select
      v-for="(options, optionsIndex) in optionsList"
      :key="'options-list-' + optionsIndex"
      v-model="values[optionsIndex]"
      :class="'form-inline form-control hierarchy-select' + ((options.length < 2) || ((readonly || disabled) && !values[optionsIndex]) ? ' hidden':'')"
      :disabled="readonly || disabled"
      @change="onChanged(optionsIndex, $event)"
    >
      <option v-if="options.length >= 2" value="">
        {{ $t('common.placeholder.select') }}
      </option>
      <option v-for="(option, optionIndex) in options" :key="'options-' + optionIndex" :value="option.value">
        {{ $t(option.text) }}
      </option>
    </select>
    <select
      v-if="getAvailableCount() < defaultShowControlCount"
      :class="'form-inline form-control hierarchy-select' + ((readonly || disabled) ? ' hidden' : '')"
      readonly="true"
    >
      <option value="">
        {{ $t('common.placeholder.select') }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    defaultShowControlCount: {
      type: Number,
      default: 3
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    fetchingChildrenUrl: {
      type: String,
      default: ''
    },
    getInitialValueUrl: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputVal: '',
      optionsList: [],
      values: []
    }
  },
  watch: {
    values: {
      handler(newVal, oldVal) {
        let val
        for (let i = newVal.length - 1; i >= 0; i--) {
          if (newVal[i]) {
            val = newVal[i]
            break
          }
        }
        if (val) {
          this.$nextTick(() => {
            this.$emit('input', val)
            this.$forceUpdate()
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.value) {
      this.getInitialValue(this.value)
    } else {
      this.fetchChildren(0, 0)
    }
  },
  methods: {
    getInitialValue(val) {
      let url = this.getInitialValueUrl
      if (url.indexOf('?') > 0) {
        url += '&'
      } else {
        url += '?'
      }
      url += 'id=' + val
      this.$axios.$get(url).then(async response => {
        if (response.resultCode === 'success') {
          this.initValues = response.data
          let parentId = 0
          for (let i = 0; i < this.initValues.length; i++) {
            await this.fetchChildren(parentId, i, this.initValues[i], true)
            parentId = this.initValues[i]
          }
          this.$forceUpdate()
        }
      })
    },
    getAvailableCount() {
      if (!this.optionsList) {
        return 0
      }
      let cnt = 0
      for (let i = 0; i < this.optionsList.length; i++) {
        if (this.optionsList[i].length) {
          cnt++
        }
      }
      return cnt
    },
    async onChanged(index, e, dontFetch) {
      if (!dontFetch) {
        await this.fetchChildren(this.values[index], index + 1)
      }
      this.$forceUpdate()
    },
    async fetchChildren(parentId, index, initVal, dontFetch) {
      if (parentId !== 0 && !parentId) {
        return
      }

      let url = this.fetchingChildrenUrl
      if (url.indexOf('?') > 0) {
        url += '&'
      } else {
        url += '?'
      }
      url += 'parentId=' + parentId
      await this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          if (this.optionsList.length > index) {
            this.optionsList.splice(index + 1)
          }
          if (index + 1 > this.optionsList.length) {
            this.optionsList.push([])
          }
          this.optionsList[index] = response.data
          if (this.values.length > index) {
            this.values.splice(index)
          }
          if (
            index > this.values.length &&
            this.optionsList[index].length > 0
          ) {
            this.values.push('')
          }
          if (initVal) {
            this.values[index] = initVal
            this.onChanged(index, undefined, dontFetch)
          } else if (this.optionsList[index].length === 1) {
            this.values[index] = this.optionsList[index][0].value
            this.onChanged(index, undefined, dontFetch)
          } else {
            this.values[index] = ''
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.hierarchy-select {
  width: auto !important;
  display: inline;
  margin-right: 10px !important;
  appearance: auto;
}
.hierarchy-select:disabled {
  height: auto;
  padding: 0;
  background: none;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  text-align: center;
}
.hierarchy-select:disabled::-ms-expand {
  display: none;
}
.hierarchy-select:disabled::before,
.hierarchy-select:disabled::after {
  background: none;
}
.hierarchy-select.hidden {
  display: none;
}
</style>
